export class Tile {
  stageId
  title
  description
  buttonText
  navigate

  constructor(tile = {}) {
    this.stageId = tile.stageId ? String(tile.stageId) : ''
    this.title = tile.title ? String(tile.title) : ''
    this.description = tile.description ? String(tile.description) : ''
    this.buttonText = tile.buttonText ? String(tile.buttonText) : ''
    this.navigate = tile.navigate ? String(tile.navigate) : ''
  }
}